import AlmasixsensesGallery from './almasixsenses/gallery.jpg';
import AlpineEscapeGallery from './alpine-escape/gallery.jpg';
import AndorraGallery from './andorra/gallery.jpg';
import AntinoriGallery from './antinori/gallery.jpg';
import AntoniewiczGallery from './antoniewicz/gallery.jpg';
import AntwerpGallery from './antwerp/gallery.jpg';
import CanMuloGallery from './canmulo/gallery.jpg';
import CaviarhouseGallery from './caviarhouse/gallery.jpg';
import ChampagneNewGallery from './champagne_new/gallery.jpg';
import CostaSmeraldaGallery from './costasmeralda/gallery.jpg';
import cotedAzurGallery from './cotedazur/gallery.jpg';
import CourchevelGallery from './courchevel/gallery.jpg';
import CourmayeurGallery from './courmayeur/gallery.jpg';
import CulturalcuratorGallery from './culturalcurator/gallery.jpg';
import EastnorGallery from './eastnor/gallery.jpg';
import FerrettiGallery from './ferretti/gallery.jpg';
import GlobeairGallery from './globeair/gallery.jpg';
import HahnenkammGallery from './hahnenkamm/gallery.jpg';
import Hahnenkamm2026Gallery from './hahnenkamm2026/gallery.jpg';
import HommageGallery from './hommage/gallery.jpg';
import IbizaGallery from './ibiza/gallery.jpg';
import InsidetrackGallery from './inside-track/gallery.jpg';
import IslandEscapeMykonosGallery from './island-escape-mykonos/gallery.jpg';
import MandarinGallery from './mandarin/gallery.jpg';
import MayrlifeGallery from './mayrlife/gallery.jpg';
import MykonosGallery from './mykonos/gallery.jpg';
import Mykonos2025Gallery from './mykonos2025/gallery.jpg';
import PrivateParisGallery from './privateparis/gallery.jpg';
import WimbledonGallery from './wimbledon/gallery.jpg';
import Wimbledon2026Gallery from './wimbledon2026/gallery.jpg';
import AlmaGallery from './alma/gallery.jpg';
import ChampagneGallery from './champagne/gallery.jpg';
import KitzbuhelGallery from './kitzbuhel/gallery.jpg'

const experienceImages = {
  AlmasixsensesGallery,
  AlpineEscapeGallery,
  AndorraGallery,
  AntinoriGallery,
  AntoniewiczGallery,
  AntwerpGallery,
  CaviarhouseGallery,
  ChampagneNewGallery,
  CanMuloGallery,
  CostaSmeraldaGallery,
  cotedAzurGallery,
  CourchevelGallery,
  CourmayeurGallery,
  CulturalcuratorGallery,
  EastnorGallery,
  FerrettiGallery,
  GlobeairGallery,
  HahnenkammGallery,
  Hahnenkamm2026Gallery,
  HommageGallery,
  IbizaGallery,
  InsidetrackGallery,
  IslandEscapeMykonosGallery,
  MandarinGallery,
  MayrlifeGallery,
  MykonosGallery,
  Mykonos2025Gallery,
  PrivateParisGallery,
  Wimbledon2026Gallery,
  WimbledonGallery,
  AlmaGallery,
  ChampagneGallery,
  KitzbuhelGallery
};

export {
  AlmasixsensesGallery,
  AlpineEscapeGallery,
  AndorraGallery,
  AntinoriGallery,
  AntoniewiczGallery,
  AntwerpGallery,
  CanMuloGallery,
  CaviarhouseGallery,
  ChampagneNewGallery,
  CostaSmeraldaGallery,
  cotedAzurGallery,
  CourchevelGallery,
  CourmayeurGallery,
  CulturalcuratorGallery,
  EastnorGallery,
  FerrettiGallery,
  GlobeairGallery,
  HahnenkammGallery,
  Hahnenkamm2026Gallery,
  HommageGallery,
  IbizaGallery,
  InsidetrackGallery,
  IslandEscapeMykonosGallery,
  MandarinGallery,
  MayrlifeGallery,
  MykonosGallery,
  Mykonos2025Gallery,
  PrivateParisGallery,
  Wimbledon2026Gallery,
  WimbledonGallery,
  AlmaGallery,
  ChampagneGallery,
  KitzbuhelGallery
};

export default experienceImages;
